import React from 'react';
import { useIsIOS } from '@shared/utils/media/useMediaScreens';
import { ButtonV1, Flex, TextV1, LinkV1 } from '@withjoy/joykit';
import { StyledEmptyCategoryImage, StyledSubtitleText } from './EmptyCategoryContent.styles';

import emptyCategoryImage from '@assets/icons/catalog-empty-category.svg';
import appStoreButtonIcon from '@assets/icons/app-store-button.svg';
import googlePlayButtonIcon from '@assets/icons/google-play-button.svg';
import { useCatalogRegistryTranslations } from '@apps/registry/common/components/Catalog/Catalog.i18n';
import { ReactComponent as GiftIcon } from '@assets/icons/registry_add_product_white.svg';

interface ProductGridProps {
  image: string;
  link: string;
  width: string;
}

const MobileButton: React.FC<ProductGridProps> = ({ image, link, width }) => {
  return (
    <LinkV1 margin="6px" href={link} underline="none" target="_blank">
      <StyledEmptyCategoryImage width={width} height="40px" photoUrl={image}></StyledEmptyCategoryImage>
    </LinkV1>
  );
};

export const EmptyCategoryContent: React.FC = () => {
  const { getEmptyCategoryContentTranslations } = useCatalogRegistryTranslations();
  const { title, subtitle, iosButton } = getEmptyCategoryContentTranslations();
  const isIOS = useIsIOS();

  const appStoreLink = 'https://apps.apple.com/us/app/joy-wedding-app-website/id994411720';
  const googlePlayLink = 'https://play.google.com/store/apps/details?id=com.withjoy.joy';
  const goToAppStore = () => {
    window.open(appStoreLink, '_blank');
  };

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" marginLeft={3} marginTop={100}>
      <StyledEmptyCategoryImage photoUrl={emptyCategoryImage} width={[279, null, 427]} height={[141, null, 215]} marginBottom={[7, null, 42]} />
      <TextV1 variant="hed6" component="h1" marginBottom={[5, null, 28]} fontSize={[28, null, 36]} fontWeight={600} textAlign="center">
        {title}
      </TextV1>
      <StyledSubtitleText
        variant="hed6"
        component="h3"
        color="#595959"
        marginBottom={[32, null, 40]}
        width={['100%', null, '400px']}
        fontSize={20}
        fontWeight={600}
        textAlign="center"
      >
        {subtitle}
      </StyledSubtitleText>
      <Flex flexDirection="row" alignItems="center" justifyContent="center" flexWrap="wrap">
        {isIOS ? (
          <ButtonV1 icon={<GiftIcon />} onClick={goToAppStore}>
            {iosButton}
          </ButtonV1>
        ) : (
          <>
            <MobileButton width="120px" link={appStoreLink} image={appStoreButtonIcon}></MobileButton>
            <MobileButton width="132px" link={googlePlayLink} image={googlePlayButtonIcon}></MobileButton>
          </>
        )}
      </Flex>
    </Flex>
  );
};
